<template>
  <div class="livelist-wrapper">
    <div class="header">
      <van-icon name="arrow-left" size="20" color="#333" @click="goBack" />
      <p class="top_title">{{title}}</p>
      <p @click="flag = !flag" class="shop_detail" :class="{'active': flag}">
        筛选
        <img v-if="flag" src="../../../static/images/ic_preview_open.png" />
        <img v-else src="../../../static/images/ic_preview_close.png" />
      </p>
    </div>
    <div class="screen_wrapper" v-if="flag && type == 3">
      <div class="screen_content">
        <div class="first_screen">
          <p @click="close(2), current = 1, isshow = false" :class="current==1?'bg':''">不限</p>
          <p @click="close(2, 0), current = 2, isshow = false" :class="current==2?'bg':''">未完成</p>
          <p @click="close(2, 1), current = 3" :class="current==3?'bg':''">已完成</p>
        </div>
      </div>
    </div>
    <div class="screen_wrapper" v-else-if="flag && type == 4">
      <div class="screen_content">
        <div class="first_screen">
          <p @click="close(3, 0), current = 1, isshow = false" :class="current==1?'bg':''">不限</p>
          <p @click="close(3, 0), current = 2, isshow = false" :class="current==2?'bg':''">未完成</p>
          <p
            @click="close(3, 1), current = 3"
            :class="current==3 || current==4 || current==5 || current==6?'bg':''"
          >已完成</p>
        </div>
      </div>
    </div>
    <div class="livelist_content">
      <div class="livelist_detail" v-for="(i, index) in data" :key="index" @click="godetail(i)">
        <p class="lesson_name">
          <span class="tag dttendance_tag" v-if="i.attendance_status!=1">未出勤</span>
          <span v-else>
            <span class="tag attendance_tag" v-if="i.enffect_attendance_status == 1">有效出勤</span>
            <span class="tag ettendance_tag" v-else>未有效出勤</span>
          </span>
          {{i.lesson_name}}
        </p>
        <p class="live_time">
          直播时间：{{formatTime(i.start_time)}}
          <span class="live_tag is_playback" v-if="i.offline_code">
            <span></span>看回放
          </span>
          <span class="live_tag" v-else>暂无回放</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";

export default {
  data() {
    return {
      data: [],
      flag: false,
      isshow: false,
      current: 0,
      title: "",
      type: this.$route.query.type
    };
  },
  mounted() {
    if (this.type == 1) {
      this.title = "直播出勤情况";
      this.getlivelist();
    } else if (this.type == 2) {
      this.title = "视频观看情况";
      this.getvideolist();
    } else if (this.type == 3) {
      this.title = "作业完成情况";
      this.gethomeworklist();
    }
  },
  methods: {
    goBack() {
      //返回
      this.$router.go(-1);
    },
    // 获取直播列表
    getlivelist(attendance_status, effect_attendance_status) {
      this.$api
        .COURSELIVELIST({
          system_order_num: this.$route.query.sn,
          business_id: this.$route.query.bc_id,
          "offcn-ticket": this.$route.query.ticket,
          start_time: this.$route.query.st,
          end_time: this.$route.query.et,
          attendance_status: attendance_status,
          effect_attendance_status: effect_attendance_status
        })
        .then(res => {
          if (res.code == 0) {
            this.data = res.data;
          }
        });
    },
    // 获取视频列表
    getvideolist(attendance_status, effect_attendance_status) {
      this.$api
        .VIDEOLIST({
          system_order_num: this.$route.query.sn,
          business_id: this.$route.query.bc_id,
          "offcn-ticket": this.$route.query.ticket,
          start_time: this.$route.query.st,
          end_time: this.$route.query.et,
          attendance_status: attendance_status,
          effect_attendance_status: effect_attendance_status
        })
        .then(res => {
          if (res.code == 0) {
            this.data = res.data;
          }
        });
    },
    // 获取作业列表
    gethomeworklist(is_done) {
      this.$api
        .COURSELIVELIST({
          system_order_num: this.$route.query.sn,
          business_id: this.$route.query.bc_id,
          "offcn-ticket": this.$route.query.ticket,
          is_done: is_done
        })
        .then(res => {
          if (res.code == 0) {
            this.data = res.data;
          }
        });
    },
    close(type, attendance_status, effect_attendance_status) {
      if (type == 1) {
        this.getlivelist(attendance_status, effect_attendance_status);
      } else if (type == 2) {
        this.getvideolist(attendance_status, effect_attendance_status);
      } else if (type == 3) {
        this.gethomeworklist(attendance_status, effect_attendance_status);
      }
      this.flag = false;
    },
    formatTime(timestamp) {
      let time = new Date(timestamp * 1000);
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let date = time.getDate();
      let hours = time.getHours();
      let minutes = time.getMinutes();
      let seconds = time.getSeconds();
      return (
        year +
        "." +
        this.addZero(month) +
        "." +
        this.addZero(date) +
        " " +
        this.addZero(hours) +
        ":" +
        this.addZero(minutes) +
        ":" +
        this.addZero(seconds)
      );
    },
    addZero(m) {
      return m < 10 ? "0" + m : m;
    },
    godetail(i) {
      if (i.offline_code) {
        this.$api
          .GETCATALOG({
            system_order_num: i.system_order,
            package_id: i.course_id,
            coding: i.cid,
            menu_id: i.lesson_id
          })
          .then(res => {
            if (res.code == 0) {
              var info = res.data.catalog.info.room_info;
              if (res.data.catalog.info.module_type == 6) {
                if (process.env.NODE_ENV == "production") {
                  location.href =
                    "//h5vod.offcncloud.com/#/vod?account=" +
                    JSON.parse(info).supervise_password;
                } else {
                  location.href =
                    "//test-h5vod.offcncloud.com/#/vod?account=" +
                    JSON.parse(info).supervise_password;
                }
              } else {
                Toast(
                  "手机浏览器暂不支持查看该课件，你可在中公教育APP进行查看"
                );
              }
            }
          });
      } else {
        Toast("暂无回放");
      }
    }
  }
};
</script>

<style lang="less">
.livelist-wrapper {
  min-height: 100%;
  background: #ffffff;
  .header {
    padding: 30px 35px 30px 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    position: fixed;
    width: 100%;
    border-bottom: 1px solid #e5e5e5;
    .shop_detail {
      font-size: 28px;
      font-weight: bold;
      color: #999999;
    }
    .active {
      color: #333333;
    }
    .shop_detail img {
      width: 20px;
      height: 20px;
      margin-left: 2px;
    }
    .top_title {
      width: 554px;
      font-size: 32px;
      font-weight: bold;
      text-align: center;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .screen_wrapper {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 104px;
    background: rgba(0, 0, 0, 0.6);
    border-top: 1px solid #e5e5e5;
    .screen_content {
      display: flex;
      text-align: center;
      font-size: 28px;
      color: #999999;
      background: #ffffff;
      div {
        padding: 30px 0;
        flex: 1;
      }
      div:first-child {
        border-right: 1px solid #e5e5e5;
      }
      p {
        padding: 30px 0;
      }
      .bg {
        color: #e60012;
      }
    }
  }
  .livelist_content {
    width: 100%;
    padding-top: 102px;
    .livelist_detail {
      padding: 30px;
      border-top: 1px solid #e5e5e5;
      .lesson_name {
        font-size: 30px;
        font-weight: bold;
        .tag {
          display: inline-block;
          font-size: 18px;
          font-weight: normal;
          padding: 3px 5px;
          border-radius: 4px;
        }
        .attendance_tag {
          color: #517a51;
          background: #e1f4e1;
        }
        .ettendance_tag {
          color: #f65d01;
          background: #ffe9d3;
        }
        .dttendance_tag {
          color: #e60012;
          background: #fce5e7;
        }
      }
      .live_time {
        font-size: 20px;
        color: #999999;
        margin-top: 10px;
        .live_tag {
          float: right;
          display: flex;
          align-items: center;
          span {
            display: inline-block;
            width: 22px;
            height: 22px;
            background: url(./static/images/huifang.png) no-repeat;
            background-size: 100%;
            margin-right: 10px;
          }
        }
        .is_playback {
          color: #e60012;
          img {
            width: 22px;
            height: 22px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/attendance/detail.vue